export default __webpack_public_path__ + "static/media/mobile_tc2_En.2e324a64.webp";